/* Nora Janne: kleurbolletjes op productkaartjes.
   Klik = de foto van het kaartje wisselt naar die kleur (geen productpagina openen).
   Het kaartje linkt daarna naar die kleur, zodat een klik op foto of titel de juiste variant opent. */
(function () {
  function kies(bol, e) {
    var kaart = bol.closest('.grid-product, .grid__item');
    if (!kaart) return;
    if (e) { e.preventDefault(); e.stopPropagation(); }
    var src = bol.getAttribute('data-nj-src');
    var srcset = bol.getAttribute('data-nj-srcset');
    var mask = kaart.querySelector('.grid-product__image-mask');
    var img = mask && (mask.querySelector('.grid__image-ratio img') || mask.querySelector('.image-wrap img'));
    if (img && src) {
      img.removeAttribute('loading');
      if (srcset) img.setAttribute('srcset', srcset);
      img.setAttribute('src', src);
      kaart.classList.add('nj-kleur-gekozen');
    }
    kaart.querySelectorAll('[data-nj-kleur]').forEach(function (b) {
      b.classList.toggle('is-actief', b === bol);
      b.setAttribute('aria-pressed', b === bol ? 'true' : 'false');
    });
    var href = bol.getAttribute('href') || bol.getAttribute('data-nj-url');
    if (href) kaart.querySelectorAll('a.grid-product__link, .grid-product__image-mask a').forEach(function (a) { a.setAttribute('href', href); });
  }
  document.addEventListener('click', function (e) {
    var bol = e.target.closest && e.target.closest('.grid-product__colors [data-nj-kleur]');
    if (bol) kies(bol, e);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var bol = e.target.closest && e.target.closest('.grid-product__colors [data-nj-kleur]');
    if (bol) kies(bol, e);
  });
})();
